import React, { forwardRef } from 'react'
import { MenuItem as MenuItemBase, styled } from '@mui/material'
import { ExpandMore as ExpandMoreBase } from '@mui/icons-material'

export const Anchor = styled('div')`
  border-bottom: 2px solid ${props => props.theme.palette.brand.black1};
  cursor: pointer;
  display: inline-flex;
  min-width: 60px;
`

export const AnchorText = styled(({ color, ...props }) => <span {...props} />)`
  color: ${props => props.theme.palette.brand[props.color]};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 1.5;
  pointer-events: none;
  margin: 0 12px 0 0;
  user-select: none;
`

export const AnchorIcon = styled(({ color, open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand[props.color]};
    font-size: 20px;
    margin: 0 0 0 auto;
    pointer-events: none;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'none')};
    user-select: none;
  }
`

export const MenuItem = styled(forwardRef(({ enableClose, ...props }, ref) => <MenuItemBase {...props} ref={ref} />))`
  &.MuiMenuItem-root {
    background-color: ${props => props.theme.palette.brand.white};
    color: ${props => props.theme.palette.gray[20]};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    letter-spacing: 0;
    line-height: 18px;
    min-height: 32px;
    padding: 7px 17px;
    transition: none;
    width: 100%;
  }

  &.MuiMenuItem-root.Mui-selected,
  &.MuiMenuItem-root.Mui-selected:hover
  &.MuiMenuItem-root.Mui-selected:focus-visible,
  &.MuiMenuItem-root.Mui-selected.Mui-focusVisible {
    background-color: ${props => props.theme.palette.gray[85]};
  }

  &.MuiMenuItem-root:focus-visible,
  &.MuiMenuItem-root:hover,
  &.MuiMenuItem-root.Mui-focusVisible { {
    background-color: ${props => props.theme.palette.gray[95]};
  }

  &.MuiMenuItem-root > .MuiTouchRipple-root {
    display: none;
  }
`
